import * as types from './types'
import { UPGRADE } from 'common/endpoints'
import { push } from 'connected-react-router'

export const goToUpgrade = (policyId, referUser, itemId) => push(UPGRADE.page(policyId, referUser, itemId))

export const fetchUpgradeDetails = search => ({
  type: types.FETCH_UPGRADE_DETAILS,
  meta: { url: UPGRADE.details(search) },
})

export const selectMembership = data => ({
  type: types.SELECT_MEMBERSHIP,
  data,
})
